import {
  Button,
  FormControlSizes,
  HStack,
  MixpanelEvent,
  MixpanelEventProperty,
  Toggle,
  useMixpanel,
} from '@talos/kyoko';
import { useMarketSelectorContext } from '../MarketSelectorContext';

export const MarketSelectorBlotterActionItems = () => {
  const { selectionsSet, unselectAll, showCredentialsOnlyToggle, credentialsOnly, setCredentialsOnly } =
    useMarketSelectorContext();
  const mixpanel = useMixpanel();

  const handleCredentialsOnlyChange = (checked: boolean) => {
    mixpanel.track(MixpanelEvent.ToggleCredentialsOnly, { [MixpanelEventProperty.Enabled]: checked });
    setCredentialsOnly(checked);
  };

  return (
    <HStack gap="spacing8">
      {showCredentialsOnlyToggle && (
        <Toggle
          label="Credentials Only"
          checked={credentialsOnly}
          onChange={handleCredentialsOnlyChange}
          tooltip="If enabled, markets without a credentialed market account set up will be hidden in the market selector."
          size={FormControlSizes.Small}
          data-testid="credentials-only-toggle"
        />
      )}
      <Button disabled={selectionsSet.size === 0} onClick={() => unselectAll()} size={FormControlSizes.Small}>
        Clear All
      </Button>
    </HStack>
  );
};
